import HomeScreen from '../screens/HomeScreen';

/**
 * CommunityRedirect
 * 
 * For authenticated users → always show HomeScreen.
 * HomeScreen handles showing communities, personal stories, etc.
 */
export default function CommunityRedirect() {
  return <HomeScreen />;
}
